import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  fieldErrorsForPrefix,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import {
  useRltOfferShowQuery,
  useRltOfferUpdatePostalAddressMutation,
  useRltOfferUpdateRepresentativeMutation,
  useRltOfferUpdateServiceAddressMutation,
} from "@/services/backend/rlt/offers/api/offer-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";

export function AddressesAndContactsRoute() {
  const { offerId } = useParams();
  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();
  const {
    data: offer,
    isLoading,
    error,
  } = useRltOfferShowQuery({
    id: offerId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={offer!.id}
        address={offer!.postalAddress}
        mutation={useRltOfferUpdatePostalAddressMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "postalAddress.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`postalAddress.${field}`)
        }
        disabled={offer!.immutable}
      />
      <ServiceAddressCardWithMutation
        id={offer!.id}
        address={offer!.serviceAddress}
        mutation={useRltOfferUpdateServiceAddressMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "serviceAddress.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`serviceAddress.${field}`)
        }
        disabled={offer!.immutable}
      />
      <RepresentativeCardWithMutation
        id={offer!.id}
        representative={offer!.representative}
        mutation={useRltOfferUpdateRepresentativeMutation}
        fieldErrors={fieldErrorsForPrefix(notReadyError, "representative.")}
        resetFieldError={(field) =>
          resetNotReadyErrorField(`representative.${field}`)
        }
        disabled={offer!.immutable}
      />
    </div>
  );
}
